"use client";

import { useAdmin } from "@/lib/admin/context";
import { Icon } from "@/lib/icons/Icon";
import styles from "./Tab.module.css";

/**
 * Tab "Katalog" — toggle CatalogAdminToolbar drawer (Faza G+).
 *
 * Workflow stanów:
 *   - active = `'catalog'` -> drawer otwarty (akcje + info)
 *   - active = `null`       -> admin przegląda jak normalny user (drawer zamknięty)
 *
 * **Toggle UX** (parity z `EditModeToggle` "Zarządzaj układem"):
 *   - klik gdy nieaktywny -> otwiera drawer
 *   - klik gdy aktywny -> zamyka drawer
 *   - klik na inny tab -> przełącza panele
 *   - klik X w drawer -> też zamyka (alternative dismiss)
 */
export function TabCatalog() {
  const { activeTab, setActiveTab, t } = useAdmin();
  const isActive = activeTab === "catalog";

  return (
    <button
      type="button"
      className={isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}
      onClick={() => setActiveTab(isActive ? null : "catalog")}
      aria-pressed={isActive}
      aria-expanded={isActive}
      title={
        isActive
          ? t.topBar.tabCatalog.titleOpen
          : t.topBar.tabCatalog.titleClosed
      }
    >
      <Icon name="folder" className={styles.icon} />
      <span>{t.topBar.tabCatalog.label}</span>
    </button>
  );
}
